import type { Notification } from '@novu/js'

export function getNotificationRedirectUrl(item: Notification): string | undefined {
  const data = item.data as { perspective?: string; redirectUrl?: string } | undefined

  if (data?.perspective === 'follower') {
    return '/community/activity'
  }

  if (typeof data?.redirectUrl === 'string' && data.redirectUrl) {
    return data.redirectUrl
  }

  const ctaUrl = item.primaryAction?.redirect?.url || item.redirect?.url
  if (typeof ctaUrl === 'string' && ctaUrl.includes('writing-feedback')) {
    return ctaUrl.startsWith('/') ? ctaUrl : '/writing-feedback'
  }

  const workflow = item.workflow?.identifier || ''
  if (
    workflow.includes('writing-habit') ||
    workflow.includes('writing_habit') ||
    workflow.includes('writing-feedback')
  ) {
    return '/writing-feedback'
  }

  return ctaUrl
}
